import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from './user-data';
import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";

@Injectable()
export class NotificationData {
  newmessages: any;
  historymessages: any;
  iNewMessages: number = 0;
  viewmode:string="";

  constructor(public http: Http, public common: CommonData, public userData: UserData) {
    this.viewmode = "new";
    this.historymessages = [];
    this.newmessages = [];
  }
  clear(){
    if(this.newmessages!=null){
      this.newmessages.length = 0;
    }
    if(this.historymessages!=null){
      this.historymessages.length = 0;
    }
  }
  markasread(notification){
    return new Promise(resolve => {
      let params = JSON.stringify({id:notification.id, token:this.userData.jwt});    
      this.http.post(this.common.baseurl+'notifications/markasread/'+notification.id,params)
        .subscribe(data => {
          let response = data.json();
          console.log(response);
          this.load();
          /*
          this.updateRequired = true;

          if(response.success === true){
              this.kont.kontid = response.data.kontid;
              resolve(true);
          }
          else{  
            console.log("fehler");
            resolve(false);  
            
          }
          */
        resolve([""]);          
        }, error => {
          resolve(false);  
      });
    });       
  }  
  load() {
    // don't have the data yet
    return new Promise(resolve => {
      if(this.userData.loggedin){

        this.http.get(this.common.baseurl+'notifications/view?mode='+this.viewmode+'&token='+this.userData.jwt).subscribe(res => {
          
          let data = res.json().data;
          //console.log(data);
          
          if(data.history != null ){
            this.historymessages = data.history;
          }
          else{
            this.historymessages.length = 0;
          }
          if(data.new != null){
            this.newmessages = data.new;
          }
          else{
            this.newmessages.length = 0;
          }
          resolve(this.newmessages);
          

        }, error => {
          console.log('HTTP Error, no answer notification-data.ts');
          console.log(error);
      });

      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/providers/notification-data.ts